import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';
import { Tooltip } from '@work4all/components/lib/components/tooltip/Tooltip';

import { PromptResult } from '@work4all/models/lib/Enums/PromptResult.enum';
import { PromptType } from '@work4all/models/lib/Enums/PromptType.enum';

import { BaseDataLanguagePickerField } from '../../../../../../../../../../components/entity-picker/BaseDataLanguagePickerField';
import { ControllerPlus } from '../../../../../../../../form-plus/controller-plus';
import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { ErpPaymentData } from '../../../../../ErpData';
import { useShadowBzObjectApiContext } from '../../../../../hooks/use-bz-shadow-object-api/use-shadow-bz-object-api-context';

export const ErpLanguagePicker = (props: { disabled?: boolean }) => {
  const { disabled } = props;
  const { t } = useTranslation();
  const { control } = useFormContextPlus<ErpPaymentData>();

  const dialogs = useDialogs();

  const shadowBzObjectApi = useShadowBzObjectApiContext();
  const positions = shadowBzObjectApi.positions;
  const promptResult = shadowBzObjectApi.promptResult;

  return (
    <Tooltip title={t('ERP.LANGUAGE_PICKER.TOOLTIP')}>
      <Box width="100px" paddingRight="0.5rem">
        <ControllerPlus
          name="language"
          control={control}
          render={({ field, fieldState }) => {
            return (
              <BaseDataLanguagePickerField
                {...field}
                clearable={false}
                disabled={disabled}
                onChange={async (e) => {
                  let confirmed = true;
                  if (positions.length > 0) {
                    confirmed = await dialogs.confirm({
                      title: t('COMMON.CHANGE'),
                      description: t('ERP.LANGUAGE_PICKER.CHANGE_QUESTION'),
                      confirmLabel: t('COMMON.YES'),
                      cancelLabel: t('COMMON.NO'),
                    });
                  }
                  promptResult.current.push({
                    result: confirmed ? PromptResult.YES : PromptResult.NO,
                    type: PromptType.BZ_OBJECT_CHANGE_LANGUAGE_REFRESH_POSITIONS,
                  });
                  field.onChange(e);
                }}
                error={fieldState?.error?.message}
              />
            );
          }}
        />
      </Box>
    </Tooltip>
  );
};
